import request from '@/api/request'

// 自定义组件：报表类目查询
export function getReportType() {
    return request({
        url: 'system/report',
        method: 'get'
    })
}

export function getPost() {
    return request({
        url: 'system/report/post',
        method: 'get'
    })
}

export function addReportType(data) {
    return request({
        url: 'system/report',
        method: 'post',
        data: data
    })
}

export function deleteReportType(data) {
    return request({
        url: 'system/report',
        method: 'delete',
        data: data
    })
}

export function addReportDetails(data) {
    return request({
        url: 'system/report/details',
        method: 'post',
        data: data
    })
}

export function getReportDetails(reportId) {
    return request({
        url: 'system/report/details',
        method: 'get',
        params: { reportId: reportId }
    })
}

export function deleteReportDetails(data) {
    return request({
        url: 'system/report/details',
        method: 'delete',
        data: data
    })
}

export function getReportDetailsByTenant(tenantId, reportId) {
    return request({
        url: 'system/report/details/tenant',
        method: 'get',
        params: { tenantId: tenantId, reportId: reportId }
    })
}

export default {
    getReportType, getPost, addReportType, deleteReportType, addReportDetails, getReportDetails, deleteReportDetails, getReportDetailsByTenant
}
